import React, { Component } from 'react';
import qs from 'qs';

import FilterButtonLink from './FilterButtonLink';
import UserSubList from 'components/UserSubList';
import Pagination from 'components/Pagination/Pagination';
import { scrollToBlock } from 'helpers/scrolls';

class UserSubs extends Component {
  componentDidMount() {
    this.fetchSubs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.userId !== this.props.userId) {
      this.fetchSubs();
    }

    if (
      (prevProps.page && prevProps.page !== this.props.page) ||
      prevProps.subFilter !== this.props.subFilter
    ) {
      this.fetchSubs();
      if (prevProps.page !== this.props.page) {
        scrollToBlock(`#${this.props.wrapperId}`);
      }
    }
  }

  fetchSubs = async () => {
    const { fetchUserFilteredSubs, userId, subFilter, subQueryMap, page } =
      this.props;
    const filterQuery = (subQueryMap && subQueryMap[subFilter]) || {};
    const searchParams = new URLSearchParams(filterQuery);
    try {
      await fetchUserFilteredSubs(
        userId,
        { query: searchParams.toString(), requestKey: subFilter },
        page,
      );
    } catch (e) {
      console.log(e);
    }
  };

  isActiveTab = (name) => name === this.props.subFilter;

  onClickHandler = (filter) => {
    const { location, history, filterKey, paginationKey } = this.props;
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    const searchParams = new URLSearchParams({
      ...query,
      [filterKey]: filter,
      [paginationKey]: 1,
    });

    history.push({
      search: `?${searchParams.toString()}`,
    });
  };

  changePageHandler = (page) => this.setState({ page });

  getNextPage = (page) => {
    const { location, paginationKey } = this.props;
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    query[paginationKey] = page;

    const searchParams = new URLSearchParams(query);
    return `${location.pathname}?${searchParams.toString()}`;
  };

  getSubsCount = (name) => {
    const { tabFilters, subsCount, filterToCountMap } = this.props;
    if (subsCount && filterToCountMap && tabFilters[name]) {
      return filterToCountMap[tabFilters[name]].reduce((acc, key) => {
        acc += subsCount[key];
        return acc;
      }, 0);
    }
  };

  render() {
    const {
      subs,
      user,
      heading,
      viewUrl,
      tabFilters,
      hideFilters,
      wrapperId,
      page,
      pageCount,
      NewUserSubLink,
      carrier,
    } = this.props;

    const filters = Object.keys(tabFilters);

    let tabButtons = null;

    if (!hideFilters) {
      tabButtons = filters.map((name, index) => (
        <FilterButtonLink
          key={tabFilters[name]}
          filter={tabFilters[name]}
          name={name}
          isActive={this.isActiveTab(tabFilters[name])}
          counter={this.getSubsCount(name)}
          useSeparator={++index !== filters.length}
          onClickHandler={this.onClickHandler}
        />
      ));
    }

    return (
      <div id={wrapperId}>
        <UserSubList
          user={user}
          subs={subs}
          heading={heading}
          viewUrl={viewUrl}
          tabButtons={tabButtons}
          carrier={carrier}
          NewUserSubLink={NewUserSubLink}
        />
        <Pagination count={pageCount} current={page} url={this.getNextPage} />
      </div>
    );
  }
}

export default UserSubs;
